/**
 * ## controller for android functions
 *
 * @module src/controller/android
 */

"use strict";

const layout = require("../../components/layout");
const modal = require("../../components/modal");
const chart = require("../../components/chart");

/**
 */

const init = (kd) => {
  document.addEventListener("backbutton", onBackKeyDown, false);
};

function onBackKeyDown() {
  if ($("#modal_block").css("display") === "block") {
    modal.destroy();
  } else if (layout.getIsExpanded()) {
    layout.toggleSidebarMax();
    setTimeout(() => {
      layout.hideKeyboard();
    }, 100);
  } else {
    chart.resetZoom();
  }
  $("#component_catch").click();
}

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/android/index.js
 **/